import React, { useState } from 'react';
import star from '../../../assets/Star.png';
import restaurant1 from '../../../assets/nbrestaurants1.png';
import './Food.css';
import OrderPopop from '../../../Components/OrderPopop';
import { HashLoader } from 'react-spinners';
import locationIcon from '../../../assets/locationImg.svg';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant';

function Restaurant({ searchTerm, results, lastElementRef, loading }) {
    const validResults = results || [];
    const [openPopop, setOpenPopop] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [RestaurantName, setRestaurantName] = useState(null);
    const [RestaurantAddress, setRestaurantAddress] = useState(null);
    const [Rating, setRating] = useState(null);
    const [vendorDistance, setVendorDistance] = useState(null);
    const [vendorRatingCount, setVendorRatingCount] = useState(null);

    const filteredRestaurants = validResults
        .filter((restaurant) =>
            restaurant?.Vendor_name?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .filter((restaurant, index, self) => 
            index === self.findIndex(r => r.VendorID === restaurant.VendorID)
        );
    console.log('filteredRestaurants',  filteredRestaurants);
    const handleVendor = (vendorID,vendorName,rating,distance,address,ratingCount) => {
        setVendorId(vendorID);
        setRestaurantName(vendorName);
        setOpenPopop(!openPopop);
        setRestaurantAddress(address);
        setRating(rating);
        setVendorDistance(distance);
        setVendorRatingCount(ratingCount);
        console.log(rating,'rating');
    };

    return (
        <div className='food-container-fake'>
            <Helmet>
                <title>{SEO.RESTAURANT_PAGE.TITLE}</title>
                <meta name="description" content={SEO.RESTAURANT_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.RESTAURANT_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                                   
                <meta property="og:title" content={SEO.RESTAURANT_PAGE.TITLE} />
                <meta property="og:description" content={SEO.RESTAURANT_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.RESTAURANT_PAGE.OG.TYPE} />
                <meta property="og:site_name" content={SEO.RESTAURANT_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                   
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.RESTAURANT_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.RESTAURANT_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            </Helmet>
            
            <div className='Food-Nearby-restaurants-cards-container'>
                <div className="justify-content-center-2">
                    {filteredRestaurants?.length > 0 && (
                        filteredRestaurants?.map((restaurant, index) => {
                            const isLastElement = index === filteredRestaurants?.length - 1;
                            return (
                                <div
                                    key={index}
                                    className='Food-search-restaurants-card'
                                    ref={isLastElement ? lastElementRef : null}
                                    onClick={() => handleVendor(restaurant?.VendorID,restaurant?.Vendor_name,restaurant?.AvgRating,restaurant?.Distance_in_Miles,restaurant?.Vendor_Address,restaurant?.Vendor_Review_User_Count)}
                                >
                                    <img
                                        className='Food-search-restaurants-image'
                                        src={restaurant?.FeatureImage || restaurant1}
                                        alt='Food img'
                                        onError={(e) => {
                                            e.target.src = restaurant1;
                                        }}
                                    />
                                    <div className='Food-search-restaurants-content'>
                                        <span className='Food-search-restaurants-text'>
                                            {restaurant?.Vendor_name}
                                        </span>
                                        <div className='Food-search-restaurant-footer'>
                                            <div className="location-miles-container">
                                                <img 
                                                    src={locationIcon} 
                                                    alt="location" 
                                                    style={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }}
                                                />
                                                <span className='Food-search-restaurant-dist'>
                                                    {restaurant?.Distance_in_Miles?.toFixed(1)} miles
                                                </span>
                                            </div>

                                            <div className='Food-dist-layout'>
                                                <img
                                                    className='Food-search-rest-star-icon-image'
                                                    src={star}
                                                    alt='search-rest-star icon'
                                                />
                                                <span className='Food-search-rest-reviews'>
                                                    {(restaurant?.AvgRating ?? 0)?.toFixed(1)} ratings
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
                {filteredRestaurants?.length === 0 && (
                    <h5 className='no-data-found'>No Restaurant Found</h5>
                )}
            </div>
            <div>
                {openPopop && 
                    <OrderPopop
                        restaurantName={RestaurantName}
                        handleClose={()=> {
                            setTimeout(() => {
                                setOpenPopop(!openPopop);
                            }, 500);
                        }}
                        vendorID={vendorId}
                        rating={Rating}
                        vendorAddress={RestaurantAddress}
                        vendorDistance={vendorDistance}
                        user_Rating_count={vendorRatingCount}
                    />
                }
            </div>
            {loading && (
                <div className='search-onload-loader'>
                    <HashLoader
                        color="#E13535"
                        loading={true}
                        size={50}
                    />
                </div>
            )}
        </div>
    );
}

export default Restaurant;
